import React, { lazy } from 'react';
import { GraduationCapIcon, FileTextIcon, ClockIcon, ShieldCheckIcon, AccessibilityIcon, MonitorIcon } from 'lucide-react';
const AVATARS = ['https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=faces&q=80', 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=80&h=80&fit=crop&crop=faces&q=80'];
const METRICS = [{
  icon: GraduationCapIcon,
  value: '1.200+',
  label: 'Scuole italiane',
  sub: 'già lo usano in classe'
}, {
  icon: FileTextIcon,
  value: '380.000+',
  label: 'Schede scaricate',
  sub: 'da inizio anno'
}, {
  icon: ClockIcon,
  value: '94%',
  label: 'Risparmia 5h+',
  sub: 'di lavoro a settimana'
}];
const CREDIBILITY = [{
  icon: ShieldCheckIcon,
  label: 'Allineato Indicazioni Nazionali'
}, {
  icon: AccessibilityIcon,
  label: 'Conforme BES & DSA'
}, {
  icon: MonitorIcon,
  label: 'Compatibile LIM, tablet & PC'
}];
export function TrustBar() {
  return <section aria-label="Prova sociale e credibilità istituzionale" className="w-full bg-bg-alt border-y border-border-light px-4 py-7 sm:py-10 relative overflow-hidden" data-id="element-383">
      {/* Subtle accent dots */}
      <div className="absolute -top-32 left-1/4 w-72 h-72 rounded-full pointer-events-none opacity-40" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.10) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-384" />
      <div className="absolute -bottom-32 right-1/4 w-72 h-72 rounded-full pointer-events-none opacity-40" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-385" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-386">
        {/* Community line — avatar stack + one tight statement */}
        <div className="flex items-center justify-center gap-3 mb-5 sm:mb-6 flex-wrap" data-id="element-387">
          <div className="flex -space-x-2.5" data-id="element-388">
            {AVATARS.map((src, i) => <img key={i} src={src} alt="" loading="lazy" width={36} height={36} className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-bg-alt object-cover bg-bg-dark" data-id="element-389" />)}
          </div>
          <p className="text-text-main text-sm sm:text-base font-semibold leading-snug text-center" data-id="element-390">
            <span className="text-primary font-black" data-id="element-391">15.000+ maestre</span>
            <span className="text-text-sec font-medium" data-id="element-392">
              {' '}
              in tutta Italia 🇮🇹
            </span>
          </p>
        </div>

        {/* Metrics row */}
        <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-5 sm:mb-6" data-id="element-393">
          {METRICS.map((m, i) => {
          const Icon = m.icon;
          return <div key={i} className="flex flex-col items-center text-center bg-bg-dark/40 border border-white/10 rounded-xl px-2 py-3 sm:px-4 sm:py-4" data-id="element-394">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-primary mb-1.5" strokeWidth={2.25} data-id="element-395" />
                <p className="text-text-main font-black text-base sm:text-2xl leading-none tracking-tight" data-id="element-396">
                  {m.value}
                </p>
                <p className="text-text-sec font-medium text-[10px] sm:text-xs mt-1 leading-tight" data-id="element-397">
                  {m.label}
                </p>
              </div>;
        })}
        </div>

        {/* Credibility row — inline, no label */}
        <div className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-2.5 pt-4 sm:pt-5 border-t border-border-light" data-id="element-398">
          {CREDIBILITY.map((c, i) => {
          const Icon = c.icon;
          return <div key={i} className="inline-flex items-center gap-1.5 bg-bg-dark/50 border border-white/10 px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-full" data-id="element-399">
                <Icon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-cta-green flex-shrink-0" strokeWidth={2.5} data-id="element-400" />
                <span className="text-text-main text-[10px] sm:text-xs font-bold whitespace-nowrap" data-id="element-401">
                  {c.label}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}